import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'yi-signup', // <yi-signup></yi-signup>
  template: require('./signup.component.html'),
  styles: [require('./signup.component.scss')],
})
export class SignupComponent implements OnInit {

  constructor(private titleService: Title) {}

  ngOnInit() {
    this.titleService.setTitle('Signup - Yotpo');
  }

}
